import { Router, ActivatedRoute } from '@angular/router';
import { PlaylistService, PublishedMatchService } from '../../../services';
import { Component, OnInit } from '@angular/core';
import { Playlist, PublishedMatch } from '../../../models';

@Component({
  selector: 'playlist-viewer',
  template: `
    <div class='container' style='margin-top: 58px' *ngIf="match">
        <clip-viewer [source]='match.media' [clips]='playlist.items' [displayName]='displayName'></clip-viewer>
    `,
  styles: []
})
export class PlaylistViewer implements OnInit {
  playlist: Playlist;
  match: PublishedMatch;
  displayName: string;
  clipShortName = 'Clip';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private publishedMatchService: PublishedMatchService,
    private playlistService: PlaylistService
  ) {}

  ngOnInit(): void {
    const playlistKey = this.activatedRoute.snapshot.params['id'];

    this.playlistService.get(playlistKey).subscribe(playlist => {
      this.playlist = playlist;

      console.info('[PlaylistViewer]', playlistKey, playlist);

      this.publishedMatchService.getByMatchId(playlist.matchId).subscribe(match => {
        this.match = match;
        this.displayName = `${match.name} - ${playlist.name}`;
      });
    });
  }
}
